import React, { useState, useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';
import MuiAlert from '@material-ui/lab/Alert';
const propTypes = {
  dispatchApiCallSuccess: PropTypes.func,
  notification: {
    warningFailure: PropTypes.any,
    msg: PropTypes.any,
  },
};

const Notification = props => {
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    isFailure: false,
  });
  const { dispatchApiCallSuccess } = props;
  const { warningFailure, msg } = props.notification;

  const { vertical, horizontal, open, message, isFailure } = state;

  useEffect(() => {
    if (warningFailure || msg) {
      if (!msg) {
        setState({
          open: true,
          message: 'Request Failed: Please refresh/log in again',
          isFailure: true,
        });
      } else handleOpen(msg, true);
    } else {
      handleClose();
    }
  }, [warningFailure, msg]);

  const handleOpen = (m, failure) => {
    setState({ open: true, message: m, isFailure: failure });
  };

  const handleClose = () => {
    setState({ open: false, message: msg });
    dispatchApiCallSuccess();
  };

  return (
    <div>
      {message && (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          key={`${vertical},${horizontal}`}
          autoHideDuration={isFailure ? 6000 : 3000}
          message={isFailure ? message : null}
          open={open}
          onClose={handleClose}
        >
          {!isFailure && (
            <MuiAlert elevation={6} variant="filled" severity="success">
              {message}
            </MuiAlert>
          )}
        </Snackbar>
      )}{' '}
    </div>
  );
};

Notification.propTypes = propTypes;

export default Notification;
